import React from 'react';

import TextInput from '@simplate/ui/TextInput';

const TextField = ({ field, form: { errors, touched }, ...rest }) => <TextInput {...rest} {...field} error={touched[field.name] && errors[field.name]} />;

export default TextField;